import React from 'react';
import s from './login.module.css';
import { BRAND } from '../../domain/brand';
import { MONTHLY_PRICE_MINOR, TRIAL_DAYS } from '../../domain/billingPlans';
import { priceTerms } from '../../domain/priceDisclosure';

// The dark half of the split sign-in screen. Hidden below the breakpoint —
// on a phone the form is the whole point.
//
// What it says (#723): who it is for, the offer, and what the product does.
// An account is one teacher (docs/environments.md), so it says independent
// music teachers. The offer is TRIAL_DAYS and the monthly price, both from
// domain/billingPlans.js, priced through `priceTerms` as the trial banner is;
// the trial asks for no card. "Keeps working when the connection drops" is the
// offline write queue (core/src/queue.rs behind src/data/writes.js), as the
// features page's FAQ says.
export default function MarketingPanel() {
  return (
    <div className={s.marketing}>
      <div className={s.brand}>
        <div className={s.markSmall} />
        <span className={s.brandName}>{BRAND.name}</span>
      </div>

      <div>
        <h2 className={s.pitch}>Scheduling and billing<br />for independent music teachers</h2>
        <p className={s.pitchBody}>
          {TRIAL_DAYS} days free with no card, then {priceTerms({ priceMinor: MONTHLY_PRICE_MINOR })}.
          Lessons, attendance, invoices and practice logs, and it keeps working when the
          connection drops.
        </p>
      </div>

      <div className={s.copyright}>© {new Date().getFullYear()} {BRAND.name}</div>
    </div>
  );
}
